import type { CountryValue } from "@/types/resources";

export const GEO_URL =
  "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

export const BASE_SCALE = 192;
export const BASE_CENTER: [number, number] = [8, 6];
export const CONTENT_HEIGHT = 460;
export const DRAG_SENSITIVITY = 0.3;

export const NUMERIC_TO_ISO2: Record<string, CountryValue> = {
  "036": "au",
  "040": "at",
  "050": "bd",
  "051": "am",
  "056": "be",
  "070": "ba",
  "076": "br",
  "100": "bg",
  "124": "ca",
  "156": "cn",
  "191": "hr",
  "196": "cy",
  "203": "cz",
  "208": "dk",
  "233": "ee",
  "246": "fi",
  "250": "fr",
  "268": "ge",
  "276": "de",
  "300": "gr",
  "344": "hk",
  "348": "hu",
  "352": "is",
  "356": "in",
  "360": "id",
  "372": "ie",
  "380": "it",
  "392": "jp",
  "398": "kz",
  "404": "ke",
  "410": "kr",
  "417": "kg",
  "428": "lv",
  "438": "li",
  "440": "lt",
  "442": "lu",
  "458": "my",
  "470": "mt",
  "484": "mx",
  "498": "md",
  "499": "me",
  "504": "ma",
  "528": "nl",
  "566": "ng",
  "578": "no",
  "586": "pk",
  "616": "pl",
  "620": "pt",
  "642": "ro",
  "643": "ru",
  "682": "sa",
  "688": "rs",
  "702": "sg",
  "703": "sk",
  "704": "vn",
  "705": "si",
  "724": "es",
  "752": "se",
  "756": "ch",
  "784": "ae",
  "792": "tr",
  "804": "ua",
  "818": "eg",
  "826": "gb",
  "840": "us",
};

export type ListRegion =
  | "africa"
  | "asia"
  | "europe"
  | "middleEast"
  | "northAmerica"
  | "oceania"
  | "southAmerica";

export const REGION_COUNTRIES: Record<ListRegion, CountryValue[]> = {
  africa: ["eg", "ke", "ma", "ng"],
  asia: [
    "bd",
    "cn",
    "hk",
    "in",
    "id",
    "jp",
    "kg",
    "kr",
    "kz",
    "my",
    "pk",
    "sg",
    "vn",
  ],
  europe: [
    "am",
    "at",
    "ba",
    "be",
    "bg",
    "ch",
    "cy",
    "cz",
    "de",
    "dk",
    "ee",
    "es",
    "fi",
    "fr",
    "gb",
    "ge",
    "gr",
    "hr",
    "hu",
    "ie",
    "is",
    "it",
    "li",
    "lt",
    "lu",
    "lv",
    "md",
    "me",
    "mt",
    "nl",
    "no",
    "pl",
    "pt",
    "ro",
    "rs",
    "ru",
    "se",
    "si",
    "sk",
    "tr",
    "ua",
  ],
  middleEast: ["ae", "sa"],
  northAmerica: ["ca", "mx", "us"],
  oceania: ["au"],
  southAmerica: ["br"],
};
